import * as stylex from '@stylexjs/stylex';
import clsx from 'clsx';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { canUseMemo } from '@/formbuilder/formbuilder.utilities';
import { Icon } from '@seeqdev/qomponents';
import type { ValidatingFormComponent } from '@/formbuilder/formBuilder.types';
import type { IconDefinition } from '@seeqdev/icons';
import type { IconType } from '@seeqdev/qomponents';

export interface IconIF extends ValidatingFormComponent<IconDefinition> {
  component: 'IconFormComponent';
  value: IconDefinition;
  onIconClick?: (event?: React.MouseEvent<SVGSVGElement>) => any;
  type?: IconType;
  color?: string;
  id?: string;
  large?: boolean;
  iconClasses?: string;
  iconXstyle?: stylex.StyleXStyles;
}

const IconFormComponentUnwrapped = (props: IconIF) => {
  const { value, tooltip, onIconClick, testId, extraClassNames, type, color, id, large, iconClasses } = props;
  const { t } = useTranslation();
  const tooltipText = tooltip ? t(tooltip) : undefined;

  return (
    <span {...stylex.props(props.xstyle)} className={clsx(stylex.props(props.xstyle).className, extraClassNames)}>
      <Icon
        type={type}
        color={color}
        id={id}
        tooltip={tooltipText ?? ''}
        large={large}
        icon={value}
        onClick={onIconClick}
        testId={testId}
        extraClassNames={iconClasses}
        xstyle={props.iconXstyle}
      />
    </span>
  );
};

export const IconFormComponent = React.memo(IconFormComponentUnwrapped, canUseMemo);
